<template>
    <SOSlotModal  
        :modal-title="titleText"
        :modal-id="id"
        :no-padding="true"
        @close="!loading && close()"
    >
        <template v-slot:modal-body>
            <div class="p-4 d-flex-column" style="gap: 10px">
                <div v-if="mode !== 'add'" class="m-b-20">
                    <SOInputSelect
                        class="p-t-2"
                        :title="'Pengaturan'"
                        :selected="formData.tipe_pengaturan_kasir"
                        :options="options"
                        :placeholder="'Pilih Pengaturan'"
                        @option-selected="
                            (val) => {
                                formData.tipe_pengaturan_kasir = val;
                            }
                        "
                    />
                </div>
                <template v-if="formData.tipe_pengaturan_kasir == 2 || mode == 'add'">
                    <SOInputSelect
                        class="p-t-2"
                        title="Pilih Outlet"
                        :selected="formData.outlet.idoutlet"
                        :options="listOutlet"
                        :placeholder="'Pilih Outlet'"
                        @option-selected="(v) => selectedOutlet(v)"
                    />
                    <div v-if="formData.outlet.idoutlet">
                        <label class="remove-margin color-6f7 font-14">
                            Pilih Kasir 
                        </label>
                        <SOInputRadioBig
                            :radio-group="pilihanKasir"
                            :radio-selected="formData.outlet.tipe_pengaturan"
                            @selected-radio="(val) => { formData.outlet.tipe_pengaturan = (val) }"
                        />
                        <div v-if="formData.outlet.tipe_pengaturan == '2'">    
                            <SOSearchAndSelectItems
                                :data-source="listKaryawan.map((item) => {
                                    return {
                                        ...item,
                                        isSelected: item.bisa_lunasi_invoice == 1
                                    }
                                })"
                                @addOptions="(v) => formData.outlet.idkaryawan = v"
                            />

                        </div>
                    </div>
                </template>
                    <SOButton
                        :disable="loading"
                        :loading="loading"
                        text="Simpan"
                        full
                        outline
                        @action="simpan()"
                    />
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import conn from "@/store/utils/connection";
import { mapGetters } from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import SOInputSearch from "@/so-components/global/input/SOInputSearch.vue";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputRadioBig from "@/so-components/global/input/SOInputRadioBig";
import SOSearchAndSelectItems from "@/modules/pengaturan-umum/components/SOSearchAndSelectItems.vue";

export default {
    name: "AturKonsumenModal",
    components: {
        SOSlotModal,
        SOInputSelect,
        SOIconBase,
        SOInputSearch,
        SOButton,
        SOInputRadioBig,
        SOSearchAndSelectItems,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        }
    },
    data () {
        return {
            id:"modal-konsumen",
            mode: 'default',
            formData: {
                outlet: {
                    idoutlet: null,
                    tipe_pengaturan: 1,
                    idkaryawan: [],
                },
                tipe_pengaturan_kasir: 1
            },
            selectedOptions: '1',
            hiddenOptions: false,
            pilihanKasir: [
                {
                    title: "Semua",
                    name: "jenis-mesin",
                    value: 1,
                    id: "semua",
                },
                {
                    title: "Sebagian",
                    name: "jenis-mesin",
                    value: 2,
                    id: "sebagian",
                },
            ],
            kasirTerpilih: 1,
            options: [
                {
                    id: 1,
                    text: "Semua Kasir Sekaligus",
                },
                {
                    id: 2,
                    text: "Hanya Kasir Tertentu",
                }
            ],
            listOutlet: [],
            listKaryawan: [],
            searcResultKasir: [],
            customerOptions: [],
        }
    },
    methods: {
        async selectedOutlet (idoutlet) {
            this.formData.outlet.idoutlet = idoutlet
            try {
                let res = await conn.get(this.$baseurl +'masterData/owner/meta/list_karyawan?idoutlet=' + idoutlet)
                console.log(res);
                if (res.data.data.length) {
                    // let filteredId = this.formData.customer.map(function(item) { 
                    //     return item.idcustomer;  
                    // });
                    // this.customerOptions = res.data.data.filter(function(item) { 
                    //     return filteredId.indexOf(item.idcustomer) < 0;  
                    // });
                    this.listKaryawan = res.data.data
                }
                else {
                    this.customerOptions = []
                }
            } catch (error) {
                console.log(error);
            }
        },
        async simpan() {
            let data = new FormData()
            let dispatchEndpoint
            
            if (this.formData.tipe_pengaturan_kasir == 2) {
                if (!this.formData.outlet.idoutlet) {
                    this.$toast.error('Outlet belum dipilih')
                    return
                }
                if (this.formData.outlet.tipe_pengaturan == 2 && !this.formData.outlet.idkaryawan.length) {
                    this.$toast.error('Kasir belum dipilih')
                    return
                }
                dispatchEndpoint = "updateOutletCanPaidOff"
                data.append("idoutlet", this.formData.outlet.idoutlet)
                data.append("tipe_pengaturan", this.formData.outlet.tipe_pengaturan)
                this.formData.outlet.idkaryawan.forEach(element => {
                    data.append("idkaryawan[]", element.idkaryawan)
                });
            }
            if (this.formData.tipe_pengaturan_kasir == 1) {
                dispatchEndpoint = "updatePelunasanInvoice"
                data.append("tipe_pengaturan_kasir", 1);
            }
            this.$emit("setLoading", true)
            //setting pengaturan outlet
            try {
                await this.$store.dispatch("pengaturanUmumModule/" + dispatchEndpoint, data)
                this.$toast.success('Pengaturan pelunasan traksaksi berhasil diupdate')
            } catch (error) {
                this.$toast.error(res.msg)
            }
            this.$emit("setLoading", false)
            this.close()
        },
        deleteKasir(id){
            this.$refs.searchInput.clearText()
            this.customerOptions = []
            console.log('delete');
            var filtered = this.formData.customer.filter(function(item) { 
                return item.idcustomer !== id;  
            });
            this.formData.customer = filtered
        },
        selectKasir(karyawan) {
            this.formData.outlet.idkaryawan.push(karyawan)
            this.searcResultKasir = this.searcResultKasir.filter((item) => {
                return item.idkaryawan != karyawan.idkaryawan
            })
            this.listKaryawan = this.listKaryawan.filter((item) => {
                return item.idkaryawan != karyawan.idkaryawan
            })
        },
        cariKasir(key) {
            if (key) {
                this.searcResultKasir = []
                this.listKaryawan.forEach(element => {
                    if (element.nama.toLowerCase().includes(key)) {
                        this.searcResultKasir.push(element)
                    }
                });
            } else {
                console.log('kosong');
                this.searcResultKasir = []
            }
        },
        open(tipe_pengaturan, mode) {
            console.log(tipe_pengaturan, mode);
            this.mode = mode || 'default'
            this.formData.tipe_pengaturan_kasir = tipe_pengaturan || 1
            this.getListOulet()
            $("#" + this.id).modal("show");
        },
        close() {
            if(this.selectedOptions == '2') this.$refs.searchInput.clearText()
            this.customerOptions = []
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
        async getListOulet() {
            try {
                let res = await conn.get(this.$baseurl +'masterData/owner/meta/list_outlet')
                this.listOutlet = res.data.data.map(item => {
                    return {
                        id: item.idoutlet,
                        text: item.nama,
                    }
                })
            } catch (error) {
                
            }
        }
    },    
    computed: {
        ...mapGetters("pengaturanUmumModule", {
            pelunasanInvoice: "pelunasanInvoice",
        }),
        titleText() {
            let title = null
            switch (this.mode) {
                case 'add':
                    title = "Tambah Kasir"
                    break;
                default:
                    title = "Pengaturan Pelunasan Invoice"
                    break;
            }
            return title
        },
        getSelectedItem() {
            return this.filterItem.konsumen;
        },
        isSelected() {
            return function(id) {
                return this.getSelectedItem.find((item) => item.id === id);
            };
        },
    },
    mounted() {
        this.getListOulet()
    },
}
</script>

<style scoped>
.name-container{
    display: flex;
    flex-flow: wrap;
    gap: 8px;
    overflow: auto;
    max-height: 150px;
}
#customer-select >>> .form-group div input{
    border: none;
}
#customer-select >>> .form-group div input:focus{
    box-shadow: none;
}
</style>